import { motion, useReducedMotion, useScroll, useSpring, useTransform } from 'framer-motion';

const SiteMotion = () => {
  const shouldReduceMotion = Boolean(useReducedMotion());
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, {
    stiffness: 110,
    damping: 28,
    restDelta: 0.001,
  });
  const ambientY = useTransform(scrollYProgress, [0, 1], [0, 420]);
  const ambientRotate = useTransform(scrollYProgress, [0, 1], [0, 32]);

  return (
    <div aria-hidden="true" className="pointer-events-none">
      <motion.div
        className="fixed inset-x-0 top-0 z-[70] h-[2px] origin-left bg-[#b7ff5a]"
        style={{ scaleX: shouldReduceMotion ? 0 : progress }}
      />
      {!shouldReduceMotion && (
        <motion.div
          className="site-ambient-orb fixed -right-64 top-[35vh] z-0 h-[32rem] w-[32rem] rounded-full"
          style={{ y: ambientY, rotate: ambientRotate }}
        />
      )}
    </div>
  );
};

export default SiteMotion;
